/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@ember/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import moment from 'moment-timezone';
import AnalyticsService from 'cio/services/analytics';
import { IntegrationSnippetType } from 'cio/utils/analytics/transforms/integrations';

export default class SetupGuideSourcesApi extends Component {
  @service environment!: EnvironmentService;
  @service analytics!: AnalyticsService;

  // private
  isShowingInstructions = false;
  nowUnixTimestamp = moment().unix();

  @action
  toggleInstructions() {
    this.toggleProperty('isShowingInstructions');

    if (this.isShowingInstructions) {
      this.analytics.track('onboarding', 'integration_details_clicked', { type: 'api' });
    }
  }

  @action
  onCopy(type: IntegrationSnippetType) {
    this.analytics.track('integration', 'api_credentials_copied', {
      credentialType: 'API',
      credentialCopied: type === 'api_track' ? 'API Track' : 'API Identify',
      source: 'Setup Guide (API Source)',
    });
  }
}
